import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { CONST } from 'src/utils/CONST'
import { useVisaOrdersPage } from '../hooks'


export const VisaFilterItem = ({ title, value, onChecked, isChecked }: { title: string, value: number[], isChecked: boolean, onChecked: (statuses: number[], state: boolean) => void }) => {

    return <label className='flex flex-row gap-2 p-1 items-center cursor-pointer rounded border border-gray-300'>
        <input checked={isChecked} className='rounded cursor-pointer' type='checkbox' onChange={({ target: { checked } }) => onChecked(value, checked)} />
        <span>{title}</span>
    </label>
}

export const Filters = () => {

    const { dispatch, selectedStatuses } = useVisaOrdersPage()

    const user = useSelector((state) => (state as any).user.user)

    const isAdmin = user?.role_key === "super_admin"

    const { t } = useTranslation();

    const handleChangeStatus = (statuses: number[], state: boolean) => {

        if (state) {
            dispatch({ selectedStatuses: [...selectedStatuses, ...statuses] })
        }
        else {
            dispatch({ selectedStatuses: selectedStatuses.filter(i => statuses.indexOf(i) == -1) })

        }
    }



    if (isAdmin)

        return (
            <div className='flex flex-col gap-2 items-start border border-gray-400 rounded-lg p-2'>

                <span className='text-gray-700'>{t('Filters')}</span>

                <div className='flex flex-row gap-2 text-gray-700 text-xs items-center flex-wrap'>




                    <VisaFilterItem
                        onChecked={handleChangeStatus}
                        title={t('AllStatuses')}
                        isChecked={CONST.adminStatus.filter(i => !i.fa.includes('؟')).length == selectedStatuses.length || selectedStatuses.length == 0}
                        value={CONST.adminStatus.filter(i => !i.fa.includes('؟')).map(i => i.id)} />



                    <span className='text-gray-500 h-6 w-[1.5px] bg-gray-400 rounded-lg'></span>

                    {CONST.adminStatus
                        .filter(i => !i.fa.includes('؟'))
                        .filter((i, index, arr) => arr.findIndex(f => f.en == i.en) == index)
                        // .reduce<Array<{ items: number[], title: string }>>((pv, cv, index, arr) => {
                        //     if (arr.findIndex(i =>i.en==cv.en))
                        //     {
                        //         const targetIndex = arr.find(i =>i.en==cv.en)
                        //         pv.push({})
                        //     }
                        //         return pv
                        // }, [])
                        // .map(i => <>{ }</>)
                        .map(item => <VisaFilterItem
                            onChecked={handleChangeStatus}
                            title={item.fa}
                            isChecked={[item.id].every(i => selectedStatuses.indexOf(i) != -1)}
                            value={CONST.adminStatus.filter(f => f.en == item.en).map(i=>i.id)} />)
                    }


                </div >
            </div>
        )

    else return <></>
}
